export const TOGGLE_LINGUAL = 'lingual/TOGGLE_LINGUAL';
export const CHANGE_LINGUAL_TO_ENGISH = 'lingual/CHANGE_LINGUAL_TO_ENGISH';
export const CHANGE_LINGUAL_TO_BANGLA = 'lingual/CHANGE_LINGUAL_TO_BANGLA';